export function base64ToArrayBuffer(data) {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function downloadPdfFromBase64Data(base64, fileName) {
  const fileNameDownload = `${fileName}.pdf`;
  var arrBuffer = base64ToArrayBuffer(base64);
  var newBlob = new Blob([arrBuffer], { type: "application/pdf" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  document.body.appendChild(link); //required in FF, optional for Chrome
  link.href = data;
  link.target = "_self";
  link.download = fileNameDownload;
  link.click();
  window.URL.revokeObjectURL(data);
  link.remove();
}

export function downloadZipFromBase64Data(base64, fileName) {
  const fileNameDownload = `${fileName}.zip`;
  var arrBuffer = base64ToArrayBuffer(base64);
  var newBlob = new Blob([arrBuffer], { type: "application/zip" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  document.body.appendChild(link); //required in FF, optional for Chrome
  link.href = data;
  link.download = fileNameDownload;
  link.click();
  window.URL.revokeObjectURL(data);
  link.remove();
}

const IR330_DOC_NAME = "IR330 electronic signature";
const KS2_DOC_NAME = "KS2 - Kiwisaver Deduction Form";
const KS10_DOC_NAME = "KS10 - Kiwisaver Opt out Request";
const DRIVERCONSENT_DOC_NAME = "Driver Information Access Consent Form";
const JOINAUNION_DOC_NAME = "Union Choice Intention";

export function isInteractivePdfDocument(documentName) {
  return documentName===IR330_DOC_NAME || documentName===KS2_DOC_NAME || documentName===KS10_DOC_NAME ||
  documentName === DRIVERCONSENT_DOC_NAME || documentName === JOINAUNION_DOC_NAME;
}

export function isIR330Document(documentName) {
  return documentName === IR330_DOC_NAME
}

export function isKS2Document(documentName) {
  return documentName === KS2_DOC_NAME
}

export function isKS10Document(documentName) {
  return documentName === KS10_DOC_NAME
}

export function isDriverConsentDocument(documentName) {
  return documentName === DRIVERCONSENT_DOC_NAME
}

export function isJoinAUnionDocument(documentName) {
  return documentName === JOINAUNION_DOC_NAME
}